<template>
    <v-btn
            :disabled="!available"
            icon
            @touchstart="undo"
            @click="undo">
        <v-icon>
            mdi-undo
        </v-icon>
    </v-btn>
</template>

<script>
    export default {
        name: "DrawingUndo",
        props: {
            available: {type: Boolean, default: false}
        },
        data() {
            return {

            }
        },
        methods: {
            undo(e) {
                e.preventDefault()
                this.$emit('undo')
            }
        }
    }
</script>